import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Modal from "react-bootstrap/Modal";
import DataTable from "react-data-table-component";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import { SearchField } from "../../../../Components/formElements/SearchField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import ReverseTimer from "../../../../Components/TableReverseTimer/ReverseTimer";
import { formatDateTime } from "../../../../common/Validations";
import { useDispatch, useSelector } from "react-redux";
import {
  addauctionNr,
  getEauction,
} from "../../../../redux/feature/supplier_app/eauctionSlice";
import { useNavigate } from "react-router-dom";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import ItemService from "../../../../services/supplier_appCommonService";
import AuctionTermsAcknowledgeModal from "../AuctionTermsAcknowledgeModal";

//  Main Component
const SupplierRevAuctionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "eAuction");
  localStorage.setItem("submenu", "Reverse Auction");

  let customerData = useSelector((state) => state.eauctionSlice.eauction);
  let customerTable = useSelector(
    (state) => state.eauctionSlice.eauction.pagination,
  );
  // const currentUser = useSelector((state) => state.authSlice?.userData);
  const currentUser = useSelector((state) => state.login?.loginData);
  console.log("Full currentUser:", currentUser);

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  // ── T&C Modal state ──────────────────────────────────────────────────────
  const [showTCModal, setShowTCModal] = useState(false);
  const [selectedAuction, setSelectedAuction] = useState(null);

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const supplierId = userData?.data?.userId || userData?.data?.AssociateNumber;

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  useEffect(() => {
    setData(customerData?.data);
  }, [customerData]);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getEauction(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getEauction(obj));
  };

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getEauction(obj));
  };

  useEffect(() => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getEauction(obj));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const auctionDetail = (auctionNr) => {
    dispatch(addauctionNr(auctionNr?.documentNumber));
    navigate(Constants.EAUCTION_SUPPLIER_AUCTION_DETAILS);
  };

  const liveAuctionDetailPage = (auctionRow) => {
    console.log("firstQuote:", auctionRow?.firstQuote);
    console.log("firstQuoteBy:", auctionRow?.firstQuoteBy);
    console.log("items:", auctionRow?.items);
    dispatch(addauctionNr(auctionRow?.documentNumber));

    // Current logged-in supplier's AssociateNumber
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const currentSupplierCode =
      userData?.data?.AssociateNumber || userData?.data?.userId;

    // Find current supplier in supplierList and check acknowledged
    const supplierEntry = auctionRow?.supplierList?.find(
      (s) => String(s.AssociateNumber) === String(currentSupplierCode),
    );

    // console.log("supplierEntry:", supplierEntry);
    // console.log("acknowledged:", supplierEntry?.acknowledged);

    if (supplierEntry?.acknowledged === true) {
      navigate(Constants.EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS);
      return;
    }

    setSelectedAuction(auctionRow);
    setShowTCModal(true);
  };

  const handleAcknowledge = async () => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const supplierId = userData?.data?.userId;

    try {
      const res = await ItemService.auctionAcknowledgeTerms({
        auctionId:
          selectedAuction?.documentNumber || selectedAuction?.auctionNr,
        supplierId: supplierId,
      });

      if (res?.status === 200) {
        setShowTCModal(false);
        setSelectedAuction(null);
        navigate(Constants.EAUCTION_SUPPLIER_LIVE_AUCTION_DETAILS);
      } else {
        toast.error(res?.message || "Acknowledge failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };
  const isAuctionExpired = (closingDateTime) => {
    if (!closingDateTime) return true;
    const now = new Date();
    const closeTime = new Date(closingDateTime);
    return now >= closeTime;
  };

  const getLiveAuctionColumn = () => ({
    name: "Live Auction",
    cell: (row) => {
      const expired = isAuctionExpired(row.closingDateTime);
      return (
        <button
          className="btn btnTable"
          onClick={() => liveAuctionDetailPage(row)}
          disabled={expired}
        >
          Live
        </button>
      );
    },
    selector: (row) => row.liveAuction1 || "--",
    sortable: true,
    width: "130px",
  });

  const [chatId, setChatId] = useState(null);
  const toggleChat = (groupId) => {
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row?.userId)}
              title={row?.userId ? "Chat With the User" : "No User Found"}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Auction Number",
      cell: (row) => (
        <button className="btnInfo" onClick={() => auctionDetail(row)}>
          {row.auctionNr || "-"}{" "}
        </button>
      ),
      selector: (row) => row.auctionNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "RFQ Number",
      selector: (row) => row.rfqNr || "--",
      sortable: true,
      cell: (row) => <button className="btnInfo">{row.rfqNr || "-"} </button>,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.auctionStatus} />
        </>
      ),
      width: "130px",
    },
    {
      name: "Start Time",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "End Time",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Remaining Time",
      cell: (row) => (
        <>
          <ReverseTimer
            openingDateTime={row.openingDateTime}
            closingDateTime={row.closingDateTime}
          />
        </>
      ),
      sortable: true,
      width: "270px",
    },
    getLiveAuctionColumn(),
    {
      name: "Comm",
      cell: (row) => <button className="btn btnTable">View</button>,
      selector: (row) => row.commType || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Order",
      cell: (row) => <button className="btn btnTable">View</button>,
      selector: (row) => row.order || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Auction Title",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionTitle}</span>
      ),
      selector: (row) => row.auctionTitle || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Auction Description",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionDescription}</span>
      ),
      selector: (row) => row.auctionDescription || "--",
      sortable: true,
      width: "130px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Supplier Auction List</h2>
                <p className="subText">
                  Lists of Supplier Auction List and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SL</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Supplier Auction List</span>
                      <span className="subHeaderTitle">
                        View of Supplier Auction List and Status
                      </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[3, 4]}
                        leftOffsets={[0, 150]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          progressPending={customerData?.status}
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <AuctionTermsAcknowledgeModal
        show={showTCModal}
        onHide={() => {
          setShowTCModal(false);
          setSelectedAuction(null);
        }}
        onAcknowledge={handleAcknowledge}
        auctionNr={
          selectedAuction?.auctionNr || selectedAuction?.documentNumber
        }
        termsText={selectedAuction?.auctionDescription}
        documentId={selectedAuction?.eventDocument}
        firstQuote={selectedAuction?.firstQuote}
        firstQuoteBy={selectedAuction?.firstQuoteBy}
        items={selectedAuction?.items || []}
        itemQuantities={selectedAuction?.itemQuantities || {}}
        currency={selectedAuction?.auctionCurrencie?.[0]?.code || "INR"}
        fractions={selectedAuction?.fractions || 2}
        auctionId={selectedAuction?.documentNumber}
        supplierId={supplierId}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
      />

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
          handlePerRowsChange
        />
      )}
    </main>
  );
};

export default SupplierRevAuctionList;
